import bunkers from './bunkers.jpg'
import canadaWater from './canadaWater.jpg'
// import cityHall from "./cityHall.jpg"
import eye from './eye.jpg'
import famimart from './famimart.jpg'
import greece from './greece.jpg'
import lloyds from './lloyds.jpg'
import mediterranian from './mediterranian.jpg'
import pink from './pink.jpg'
import poseidon from './poseidon.jpg'
import sunrise from './sunrise.jpg'
// import sunset from "./sunsetShard.jpg"
import thames from './thames.jpg'
// import tower from "./tower.jpg"
import trafalgar from './trafalgar.jpg'

let images = [
  {
    location: 'Barcelona, Spain',
    img: bunkers,
  },
  {
    location: 'London, UK',
    img: canadaWater,
  },
  {
    location: 'London, UK',
    img: eye,
  },
  {
    location: 'Tokyo, Japan',
    img: famimart,
  },
  {
    location: 'Sounio, Greece',
    img: mediterranian,
  },
  {
    location: 'London, UK',
    img: lloyds,
  },
  {
    location: 'Sounio, Greece',
    img: poseidon,
  },
  {
    location: 'Vouliagmeni, Greece',
    img: greece,
  },
  {
    location: 'Athens, Greece',
    img: sunrise,
  },
  {
    location: 'Somewhere, Earth',
    img: pink,
  },
  {
    location: 'London, UK',
    img: thames,
  },
  {
    location: 'London, UK',
    img: trafalgar,
  },
]

export default images
